export const getPresignedUrl = "/api/generate-presigned-url";
export const startLabelDetection = "/api/start-label-detection";
export const getLabelDetectionResults = "/api/get-label-detection-results";
